import * as React from 'react'

function Recent(props: any) {
  return (
    <svg width='20' height='26' viewBox='0 0 20 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 24C5.967 20.3455 0 12.6997 0 8.1289C0 3.64639 4.03714 0 9 0C13.9629 0 18 3.64639 18 8.1289C18 12.6997 12.033 20.3466 9 24'
        transform='translate(1 1)'
        stroke='#838383'
        strokeWidth='1.5'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.65517 6.31705H0V0H1.5458V4.94764H5.65517V6.31705Z'
        transform='translate(8 5.5)'
        fill='#838383'
      />
    </svg>
  )
}

export default Recent



// WEBPACK FOOTER //
// ./src/components/icons/ui/Recent.tsx